/*
  MacShack home page (sections/ms-home.liquid)
  - Budget finder: picks the best in-stock match from each product family under the chosen budget.
  - "New in this week" row arrows.
  - The MacShack check: steps tick off as you scroll through them (everything shows as done at rest).
*/
(function () {
  var reduced = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  function money(n) { return 'R' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function condClass(c) { return c === 'New' ? 'cond--new' : c === 'Demo' ? 'cond--demo' : 'cond--pre'; }

  function initBudget(box) {
    var items = [];
    try { items = JSON.parse(box.querySelector('[data-budget-items]').textContent) || []; } catch (e) { items = []; }
    var seen = {};
    items = items.filter(function (x) { if (!x.p || seen[x.u]) return false; seen[x.u] = 1; return true; });
    var range = box.querySelector('[data-budget-range]'), val = box.querySelector('[data-budget-val]'), out = box.querySelector('[data-budget-results]');
    var presets = Array.prototype.slice.call(box.querySelectorAll('.presets button'));
    var all = box.getAttribute('data-all') || '/collections/all';
    function family(n) { return n.split(' ').slice(0, 2).join(' '); }
    function render(v) {
      val.textContent = money(v);
      range.style.setProperty('--fill', ((v - range.min) / (range.max - range.min) * 100) + '%');
      presets.forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-v') === v ? 'true' : 'false'); });
      var fit = items.filter(function (x) { return x.p <= v; }).sort(function (a, b) { return b.p - a.p; });
      var pick = [], fams = {};
      fit.forEach(function (x) { var f = family(x.n); if (pick.length < 4 && !fams[f]) { fams[f] = 1; pick.push(x); } });
      var html = pick.map(function (x, i) {
        return '<a class="res" style="animation-delay:' + (i * 50) + 'ms" href="' + x.u + '">' + (x.i ? '<img src="' + x.i + '" alt="" loading="lazy" width="88" height="88">' : '') +
          '<div><span class="cond ' + condClass(x.c) + '" style="align-self:flex-start">' + x.c + '</span><b>' + esc(x.n) + '</b><span><span class="price">' + money(x.p) + '</span>' +
          (x.w > x.p ? ' <span class="was" style="font-size:13px">' + money(x.w) + '</span>' : '') + '</span></div></a>';
      }).join('');
      if (!pick.length) html = '<p style="grid-column:1/-1;color:var(--ink-2)">Nothing in stock at this price right now. Try a higher budget, or WhatsApp us and we\'ll look for you.</p>';
      var sep = all.indexOf('?') > -1 ? '&' : '?';
      html += '<div class="results__foot"><span>' + (fit.length > pick.length ? fit.length + ' devices in stock at this price. Showing the best match from each range.' : 'Showing everything in stock at this price.') + '</span>' +
        '<a class="btn btn--buy" href="' + all + sep + 'filter.v.price.lte=' + v + '&sort_by=price-descending">See everything under ' + money(v) + '</a></div>';
      out.innerHTML = html;
    }
    range.addEventListener('input', function () { render(+range.value); });
    presets.forEach(function (b) { b.addEventListener('click', function () { range.value = b.getAttribute('data-v'); render(+range.value); }); });
    render(+range.value);
  }

  function initRail(wrap) {
    var rail = wrap.querySelector('[data-rail]'), prev = wrap.querySelector('[data-rail-prev]'), next = wrap.querySelector('[data-rail-next]');
    if (!rail || !prev || !next) return;
    function step() { var c = rail.querySelector('.card'); return c ? c.offsetWidth + 12 : 300; }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduced() ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduced() ? 'auto' : 'smooth' }); });
    function ends() { prev.disabled = rail.scrollLeft < 4; next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4; }
    rail.addEventListener('scroll', ends, { passive: true }); window.addEventListener('resize', ends); ends();
  }

  function initCheck(sec) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    var steps = Array.prototype.slice.call(sec.querySelectorAll('.step'));
    var arc = sec.querySelector('[data-ring]'), num = sec.querySelector('[data-ring-num]'), title = sec.querySelector('[data-ring-title]'), sub = sec.querySelector('[data-ring-sub]');
    if (!steps.length || !arc) return;
    var C = 138.2;
    arc.style.transition = 'stroke-dashoffset .6s cubic-bezier(.2,.7,.2,1)';
    function setDone(n) {
      steps.forEach(function (s, i) { s.classList.toggle('is-done', i < n); });
      arc.style.strokeDashoffset = C * (1 - n / steps.length);
      num.textContent = n + '/' + steps.length;
      var all = n === steps.length;
      title.textContent = all ? 'Ready for you' : (n ? steps[n - 1].querySelector('h3').textContent : 'Starting checks');
      sub.textContent = all ? 'All checks passed' : 'Check ' + n + ' of ' + steps.length;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = steps.indexOf(e.target) + 1;
        var cur = steps.filter(function (s) { return s.classList.contains('is-done'); }).length;
        if (i > cur) setDone(i);
      });
    }, { rootMargin: '0px 0px -45% 0px' });
    /* Only replay the sequence when the section comes into view from above, so the resting page shows all checks done. */
    new IntersectionObserver(function (en, obs) {
      if (en[0].isIntersecting && en[0].boundingClientRect.top > window.innerHeight * 0.3) {
        obs.disconnect(); setDone(0); steps.forEach(function (s) { io.observe(s); });
      }
    }, { threshold: [0, 0.05] }).observe(sec);
  }

  function init(root) {
    if (root.__mhp) return; root.__mhp = true;
    var b = root.querySelector('[data-budget]'); if (b) initBudget(b);
    var r = root.querySelector('[data-rail-wrap]'); if (r) initRail(r);
    var c = root.querySelector('[data-check]'); if (c) initCheck(c);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mhp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
